module.exports = __webpack_public_path__ + "static/media/back.04e95692.jpg";